module.exports = __webpack_public_path__ + "static/img/after-sale-swan-0.aaf7ddde.png";